/* Ivy Row — Interactive Enhancements */
(function(){
'use strict';
if(window.__irEnhance)return;
window.__irEnhance=true;
var raf=window.requestAnimationFrame;
if(!raf)return;
var mm=window.matchMedia('(prefers-reduced-motion: reduce)');
if(mm.matches)return;

/* ── 1. Scroll Reveal ── */
function initReveal(){
  if(!('IntersectionObserver' in window))return;
  var sections=document.querySelectorAll('.wh-sec');
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      e.target.classList.add('ir-reveal','is-in');
      var kids=e.target.querySelectorAll('.wh-scroller__item,.wh-uni__link,.card,.wh-ugc__item,.wh-brand__item');
      kids.forEach(function(kid,i){
        kid.style.transitionDelay=(i*60)+'ms';
        kid.classList.add('ir-reveal');
        setTimeout(function(){kid.classList.add('is-in');},50);
      });
      io.unobserve(e.target);
    });
  },{threshold:0.08,rootMargin:'0px 0px -60px 0px'});
  sections.forEach(function(s){io.observe(s);});
}

/* ── 2. 3D Tilt on Product Cards ── */
function initTilt(){
  if('ontouchstart' in window)return;
  var cards=document.querySelectorAll('.card');
  cards.forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5;
      var y=(e.clientY-r.top)/r.height-.5;
      raf(function(){
        card.style.transform='perspective(800px) rotateY('+x*5+'deg) rotateX('+-y*3+'deg) translateY(-6px)';
      });
    });
    card.addEventListener('mouseleave',function(){
      raf(function(){
        card.style.transform='';
        card.style.transition='transform .5s cubic-bezier(.2,.8,.2,1),box-shadow .5s cubic-bezier(.2,.8,.2,1)';
        setTimeout(function(){card.style.transition='';},500);
      });
    });
  });
}

/* ── 3. Collection Circle 3D Tilt ── */
function initCircleTilt(){
  if('ontouchstart' in window)return;
  var items=document.querySelectorAll('.wh-uni__link');
  items.forEach(function(item){
    var ring=item.querySelector('.wh-uni__ring');
    if(!ring)return;
    item.addEventListener('mousemove',function(e){
      var r=item.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5;
      var y=(e.clientY-r.top)/r.height-.5;
      raf(function(){
        ring.style.transform='perspective(400px) rotateY('+x*10+'deg) rotateX('+-y*8+'deg) scale(1.06)';
      });
    });
    item.addEventListener('mouseleave',function(){
      raf(function(){
        ring.style.transform='';
        ring.style.transition='transform .6s cubic-bezier(.2,.8,.2,1),box-shadow .5s';
        setTimeout(function(){ring.style.transition='';},600);
      });
    });
  });
}

/* ── 4. Brand Tile 3D Tilt ── */
function initBrandTilt(){
  if('ontouchstart' in window)return;
  var tiles=document.querySelectorAll('.wh-brand__tile');
  tiles.forEach(function(tile){
    tile.addEventListener('mousemove',function(e){
      var r=tile.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5;
      var y=(e.clientY-r.top)/r.height-.5;
      raf(function(){
        tile.style.transform='perspective(600px) rotateY('+x*4+'deg) rotateX('+-y*3+'deg) translateY(-4px) scale(1.03)';
      });
    });
    tile.addEventListener('mouseleave',function(){
      raf(function(){
        tile.style.transform='';
        tile.style.transition='transform .5s cubic-bezier(.2,.8,.2,1),box-shadow .5s';
        setTimeout(function(){tile.style.transition='';},500);
      });
    });
  });
}

/* ── 5. Magnetic Buttons ── */
function initMagnetic(){
  if('ontouchstart' in window)return;
  var btns=document.querySelectorAll('.wh-btn--primary,.wh-hero__btn,.whcd-btn--primary');
  btns.forEach(function(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      var cx=r.left+r.width/2;
      var cy=r.top+r.height/2;
      var dx=(e.clientX-cx)*.12;
      var dy=(e.clientY-cy)*.12;
      raf(function(){
        btn.style.transform='translate('+dx+'px,'+dy+'px)';
      });
    });
    btn.addEventListener('mouseleave',function(){
      raf(function(){
        btn.style.transform='';
        btn.style.transition='transform .4s cubic-bezier(.2,.8,.2,1)';
        setTimeout(function(){btn.style.transition='';},400);
      });
    });
  });
}

/* ── 6. Hero Parallax ── */
function initParallax(){
  var hero=document.querySelector('.wh-hero');
  if(!hero)return;
  var img=hero.querySelector('.wh-hero__bg-img');
  if(!img)return;
  var ticking=false;
  window.addEventListener('scroll',function(){
    if(ticking)return;
    ticking=true;
    raf(function(){
      var r=hero.getBoundingClientRect();
      if(r.bottom>0&&r.top<window.innerHeight){
        var pct=r.top/(window.innerHeight+r.height);
        img.style.transform='scale(1.08) translateY('+(pct*-25)+'px)';
      }
      ticking=false;
    });
  },{passive:true});
}

/* ── 7. Cursor Glow on Hero ── */
function initCursorGlow(){
  if('ontouchstart' in window)return;
  var hero=document.querySelector('.wh-hero');
  if(!hero)return;
  var glow=document.createElement('div');
  glow.style.cssText='position:absolute;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(197,165,90,.08) 0%,transparent 70%);pointer-events:none;z-index:3;transform:translate(-50%,-50%);opacity:0;transition:opacity .4s;mix-blend-mode:screen';
  hero.style.position=hero.style.position||'relative';
  hero.style.overflow='hidden';
  hero.appendChild(glow);
  hero.addEventListener('mousemove',function(e){
    var r=hero.getBoundingClientRect();
    glow.style.left=(e.clientX-r.left)+'px';
    glow.style.top=(e.clientY-r.top)+'px';
    glow.style.opacity='1';
  });
  hero.addEventListener('mouseleave',function(){
    glow.style.opacity='0';
  });
}

/* ── 8. PDP Image Zoom ── */
function initPdpZoom(){
  if('ontouchstart' in window)return;
  var media=document.querySelector('.wh-pdp__media');
  if(!media)return;
  var img=media.querySelector('img');
  if(!img)return;
  media.addEventListener('mousemove',function(e){
    var r=media.getBoundingClientRect();
    var x=(e.clientX-r.left)/r.width*100;
    var y=(e.clientY-r.top)/r.height*100;
    raf(function(){
      img.style.transformOrigin=x+'% '+y+'%';
      img.style.transform='scale(1.5)';
    });
  });
  media.addEventListener('mouseleave',function(){
    raf(function(){
      img.style.transform='';
      img.style.transition='transform .5s cubic-bezier(.2,.8,.2,1)';
      setTimeout(function(){img.style.transition='';},500);
    });
  });
}

/* ── 9. Stagger Children ── */
function initStagger(){
  var groups=document.querySelectorAll('.wh-uni__list,.wh-trust__grid,.wh-brand__grid');
  groups.forEach(function(g){
    var children=g.children;
    for(var i=0;i<children.length;i++){
      children[i].style.transitionDelay=(i*60)+'ms';
    }
  });
}

/* ── Init ── */
function init(){
  initReveal();
  initTilt();
  initCircleTilt();
  initBrandTilt();
  initMagnetic();
  initParallax();
  initCursorGlow();
  initPdpZoom();
  initStagger();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}
})();
